import React from 'react';
import {
  BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Cell, ResponsiveContainer
} from 'recharts';

const FUNNEL_COLORS = ['#4841F0', '#6366f1', '#8b5cf6', '#10b981', '#ef4444'];

const PipelineFunnelChart = ({ data }) => {
  const sum = (key) => (data || []).reduce((acc, r) => acc + (r[key] || 0), 0);

  const chartData = [
    { stage: 'Screening Calls', value: sum('screeningCalls') },
    { stage: 'Passed Screening', value: sum('passedAfterScreening') },
    { stage: 'Final Stages', value: sum('finalStages') },
    { stage: 'Offers Accepted', value: sum('offersAccepted') },
    { stage: 'Offers Rejected', value: sum('offersRejected') },
  ];

  const max = Math.max(...chartData.map(d => d.value), 1);

  const CustomTooltip = ({ active, payload }) => {
    if (active && payload && payload.length) {
      const item = payload[0].payload;
      const pct = chartData[0].value > 0 ? Math.round((item.value / chartData[0].value) * 100) : 0;
      return (
        <div style={{ borderRadius: '8px', border: 'none', boxShadow: '0 4px 6px -1px rgba(0,0,0,0.1), 0 2px 4px -1px rgba(0,0,0,0.06)', fontSize: '12px', padding: '8px 12px', background: '#fff' }}>
          <p className="font-semibold text-gray-800">{item.stage}</p>
          <p className="text-gray-600">{item.value} total</p>
          {item.stage !== 'Screening Calls' && (
            <p className="text-gray-400 text-xs">{pct}% of screening</p>
          )}
        </div>
      );
    }
    return null;
  };

  return (
    <div className="dashboard-card p-6 slide-in-up">
      <div className="flex justify-between items-center mb-3">
        <h3 className="text-lg font-semibold text-gray-800">Pipeline Funnel</h3>
        <div className="bg-indigo-100 text-indigo-800 text-xs font-medium px-2.5 py-1 rounded-full">
          Filtered Data
        </div>
      </div>
      <p className="text-sm text-gray-600 mb-4">Candidate progression from screening to offer for selected filters</p>
      {chartData[0].value === 0 ? (
        <div className="flex items-center justify-center h-48 text-gray-400 text-sm">No data available</div>
      ) : (
        <ResponsiveContainer width="100%" height={250}>
          <BarChart data={chartData} margin={{ top: 4, right: 16, left: 0, bottom: 60 }}>
            <CartesianGrid strokeDasharray="3 3" stroke="#f0f0f0" vertical={false} />
            <XAxis dataKey="stage" tickLine={false} axisLine={false} style={{ fontSize: '12px' }} angle={-30} textAnchor="end" interval={0} />
            <YAxis tickLine={false} axisLine={false} style={{ fontSize: '12px' }} allowDecimals={false} domain={[0, max]} />
            <Tooltip content={<CustomTooltip />} />
            <Bar dataKey="value" name="Count" radius={[4, 4, 0, 0]}>
              {chartData.map((entry, index) => (
                <Cell key={index} fill={FUNNEL_COLORS[index % FUNNEL_COLORS.length]} />
              ))}
            </Bar>
          </BarChart>
        </ResponsiveContainer>
      )}
    </div>
  );
};

export default PipelineFunnelChart;
